// import {
//   Box,
//   Button,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Stack,
//   Typography,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { hideModal } from "../../store/slice/modalSlice";
// import { useDispatch } from "react-redux";
// import { useEffect, useState } from "react";

// interface PropType {
//   isOpen: boolean;
//   data?: any;
// }

// export default function PrelimitFiltersInfoModel(props: PropType) {
//   const { isOpen, data } = props;
//   const dispatch = useDispatch();
//   console.log("PRELIMIT_FILTERS_INFO_MODEL", data);

//   const [parsedData, setParsedData] = useState<{
//     keyword: string | null;
//     documentTypes: string[];
//     subjects: string[];
//   } | null>(null);

//   useEffect(() => {
//     if (data) {
//       const result = extractValues(data);
//       setParsedData(result);
//     }
//   }, [data]);

//   function extractValues(input: string) {
//     const cleanText = input.replace(/\\"/g, '"');

//     ///const scienceMatch = cleanText.match(/^"?(.*?)",\s*Document Types:/);
//     const keywordMatch = cleanText.match(/^"?([^,]+),/);
//     const docTypesMatch = cleanText.match(/Document Types:\s*\[([^\]]+)\]/);
//     const subjectsMatch = cleanText.match(/Subjects Name L2:\s*\[([^\]]+)\]/);

//     const splitAndClean = (str: any) =>
//       str
//         .split("', '")
//         .map((s: any) => s.replace(/^'/, "").replace(/'$/, "").trim());

//     // extract and clean values
//     let documentTypes = docTypesMatch ? splitAndClean(docTypesMatch[1]) : [];
//     let subjects = subjectsMatch ? splitAndClean(subjectsMatch[1]) : [];
//     documentTypes = documentTypes.map((doc: string) =>
//       doc === "Journals" ? "Journal Articles" : doc,
//     );

//     return {
//       //   keyword: scienceMatch?.[1]?.trim() || keywordMatch?.[1] || null,
//       keyword: keywordMatch?.[1] || null,
//       documentTypes,
//       subjects,
//       // documentTypes: docTypesMatch ? splitAndClean(docTypesMatch[1]) : [],
//       // subjects: subjectsMatch ? splitAndClean(subjectsMatch[1]) : [],
//     };
//   }

//   return (
//     <Dialog
//       open={isOpen}
//       onClose={() => dispatch(hideModal())}
//       maxWidth={false}
//       // sx={{ width: { xs: "100%", sm: "400px", md: "50%", lg: "50%" } }}
//       //maxWidth={sm:"small", lg::medium}
//     >
//       <DialogTitle
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           //minWidth: { xs: "100%", sm: "400px", md: "550px", lg: "900px" },
//           //width: "400px",
//         }}
//       >
//         <div>
//           <Typography
//             variant="h6"
//             fontWeight={"bold"}
//             // fontSize="30px"
//             fontFamily="Lora"
//             sx={{
//               fontSize: {
//                 xs: "22px", // For extra small screens
//                 sm: "22px", // For small screens
//                 md: "22px", // For medium screens and above
//                 lg: "22px",
//               },
//             }}
//           >
//             Pre-Limits Applied
//           </Typography>
//         </div>
//         <div>
//           <IconButton onClick={() => dispatch(hideModal())}>
//             <CloseIcon />
//           </IconButton>
//         </div>
//       </DialogTitle>

//       <DialogContent sx={{ mt: "10px" }}>
//         {/* <Typography sx={{ fontSize: "20px" }}> */}

//         {parsedData && (
//           <Box sx={{ display: "flex", flexDirection: "column" }}>
//             {/* {parsedData.keyword && (
//               <Stack
//                 sx={{
//                   maxWidth: 500,
//                   flexDirection: { xs: "column", sm: "row" },
//                 }}
//               >
//                 <Typography sx={{ fontWeight: 600 }}>Search Term:</Typography>
//                 <Typography marginLeft={{ xs: "0px", sm: "4px" }}>
//                   {parsedData.keyword}
//                 </Typography>
//               </Stack>
//             )} */}

//             {parsedData.documentTypes?.length > 0 && (
//               <Stack sx={{ maxWidth: 500 }}>
//                 <Typography sx={{ fontWeight: 600 }}>
//                   Document Types:
//                 </Typography>
//                 <Typography>{parsedData.documentTypes.join(", ")}</Typography>
//               </Stack>
//             )}

//             {parsedData.subjects?.length > 0 && (
//               <Stack sx={{ maxWidth: 500 }}>
//                 <Typography sx={{ fontWeight: 600 }}>
//                   Subjects Names:
//                 </Typography>
//                 <Typography>{parsedData.subjects.join(", ")}</Typography>
//               </Stack>
//             )}
//           </Box>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// }

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { hideModal } from "../../store/slice/modalSlice";
import { useDispatch } from "react-redux";

interface ModalData {
  mouseOverData: string;
  searchType: string;
}

interface PropType {
  isOpen: boolean;
  data?: ModalData;
}

interface ParsedData {
  searchQuery: string | null;
  documentTypes: string[];
  subjects: string[];
}

export default function PrelimitFiltersInfoModel({ isOpen, data }: PropType) {
  const dispatch = useDispatch();

  const extractValues = (input: string, searchType?: string): ParsedData => {
    const cleanText = input.replace(/\\"/g, '"');

    // Handle InsightAI searches
    if (searchType === "J-Gate InsightAI") {
      const titleKeywordsMatch = cleanText.match(
        /titleKeywordsAbs=(.*?)(&fq__|$)/,
      );

      return {
        searchQuery: titleKeywordsMatch?.[1]?.trim() || null,
        documentTypes: [],
        subjects: [],
      };
    }

    // Handle Document Types & Subjects
    const docTypesMatch = cleanText.match(/Document Types:\s*\[([^\]]+)\]/);

    const subjectsMatch = cleanText.match(/Subjects Name L2:\s*\[([^\]]+)\]/);

    const splitAndClean = (str: string): string[] =>
      str
        .split("', '")
        .map((s) => s.replace(/^'/, "").replace(/'$/, "").trim());

    const documentTypes = docTypesMatch
      ? splitAndClean(docTypesMatch[1]).map((doc) =>
          doc === "Journals" ? "Journal Articles" : doc,
        )
      : [];

    const subjects = subjectsMatch
      ? [...new Set(splitAndClean(subjectsMatch[1]))]
      : [];

    return {
      searchQuery: null,
      documentTypes,
      subjects,
    };
  };

  const parsedData = data?.mouseOverData
    ? extractValues(data.mouseOverData, data.searchType)
    : null;

  return (
    <Dialog
      open={isOpen}
      onClose={() => dispatch(hideModal())}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: {
            xs: "95%",
            sm: "700px",
            md: "900px",
          },
          maxWidth: "900px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          fontFamily="Lora"
          sx={{ fontSize: "22px" }}
        >
          {data?.searchType === "J-Gate InsightAI"
            ? "Semantic Query Expansion"
            : "Pre-Limits Applied"}
        </Typography>

        <IconButton onClick={() => dispatch(hideModal())}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {parsedData && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* InsightAI Search Query */}
            {data?.searchType === "J-Gate InsightAI" &&
              parsedData.searchQuery && (
                <Stack>
                  {/* <Typography sx={{ fontWeight: 600 }}>
                    Search Query:
                  </Typography> */}

                  <Typography
                    sx={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {parsedData.searchQuery}
                  </Typography>
                </Stack>
              )}

            {/* Document Types */}
            {parsedData.documentTypes.length > 0 && (
              <Stack>
                <Typography sx={{ fontWeight: 600 }}>
                  Document Types:
                </Typography>

                <Typography>{parsedData.documentTypes.join(", ")}</Typography>
              </Stack>
            )}

            {/* Subjects */}
            {parsedData.subjects.length > 0 && (
              <Stack>
                <Typography sx={{ fontWeight: 600 }}>Subject Names:</Typography>

                <Typography>{parsedData.subjects.join(", ")}</Typography>
              </Stack>
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
